import { render, staticRenderFns } from "./SettingProfil.vue?vue&type=template&id=64f2b7b3&scoped=true&"
import script from "./SettingProfil.vue?vue&type=script&lang=js&"
export * from "./SettingProfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f2b7b3",
  null
  
)

export default component.exports